// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ivjevyrhkbinqtpvwbze.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml2amV2eXJoa2JpbnF0cHZ3YnplIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkyMzkyMDksImV4cCI6MjA2NDgxNTIwOX0.LYqQodmdsc6P38QHHdu8GM_PUTBe-XkfZqTUT3IlkQg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);